import { useCallback, useState } from "react";
import { usePostHogEvent } from "@/lib/posthog";
import { HotTakesComposer } from "./hot-takes-composer";
import {
  HotTakesModePicker,
  type HotTakesMode,
} from "./hot-takes-mode-picker";

interface HotTakesDialogHostProps {
  open: boolean;
  mentorshipId: string;
  teenName: string;
  onOpenChange: (open: boolean) => void;
}

export function HotTakesDialogHost({
  open,
  mentorshipId,
  teenName,
  onOpenChange,
}: HotTakesDialogHostProps) {
  const [mode, setMode] = useState<HotTakesMode | null>(null);
  const { dispatchEvent } = usePostHogEvent("activity.mentor");

  const handleClose = useCallback(() => {
    setMode(null);
    onOpenChange(false);
  }, [onOpenChange]);

  const handleModeSelected = useCallback(
    (nextMode: HotTakesMode) => {
      dispatchEvent("activity.mentor.compose_mode_selected", {
        mentorshipId,
        mode: nextMode,
      });
      setMode(nextMode);
    },
    [dispatchEvent, mentorshipId],
  );

  const handleBack = useCallback(() => {
    setMode(null);
    onOpenChange(true);
  }, [onOpenChange]);

  return (
    <>
      <HotTakesModePicker
        isOpen={open && !mode}
        onClose={handleClose}
        onSelectMode={handleModeSelected}
      />

      {mode ? (
        <HotTakesComposer
          isOpen={open}
          mode={mode}
          mentorshipId={mentorshipId}
          teenName={teenName}
          onClose={handleClose}
          onBack={handleBack}
          onSent={() => {
            dispatchEvent("activity.mentor.sent", {
              mentorshipId,
              activityType: "hot_takes",
            });
          }}
        />
      ) : null}
    </>
  );
}
